import React from 'react';

import './search_different.scss';
import { FormattedMessage } from 'react-intl';

export class SearchDifferent extends React.Component<{}> {
  render() {
    return (
      <div className="banner-customers">
        <div className="banner-customers__block">
          <div className="search-different__header">
            <h1 className="search-different__header__title">
              <FormattedMessage id="presentation/SearchDifferent.tsx/1" />
            </h1>
            <p className="search-different__header__subtitle">
              <FormattedMessage id="presentation/SearchDifferent.tsx/2" />
            </p>
          </div>
        </div>
      </div>
    );
  }
}
